import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { mainProduct } from '../data/product';
import { getPremiumGalleryForColor } from '../images';
import { metaTrackCustomizeProduct } from '../analytics/metaPixel';
import './PremiumLanding.css';

const COLOR_OPTIONS = [
    { value: 'Зелен', label: 'Зелен' },
    { value: 'Сив', label: 'Сив' }
];

function PremiumLanding() {
    const { addToCart } = useCart();
    const navigate = useNavigate();
    const [selectedColor, setSelectedColor] = useState(null);

    const gallery = useMemo(() => {
        if (selectedColor == null) {
            return mainProduct.images;
        }
        return getPremiumGalleryForColor(selectedColor);
    }, [selectedColor]);

    const handleBuyClick = () => {
        if (selectedColor == null) return;
        addToCart({
            ...mainProduct,
            image: gallery[0],
            images: gallery,
            selectedSize: 'N/A',
            selectedColor,
            quantity: 1
        });
        navigate('/cart');
    };

    const canBuy = selectedColor != null;

    return (
        <main className="premium-landing">
            <section className="premium-hero">
                <div className="premium-hero-media">
                    <img src={gallery[0]} alt={mainProduct.name} />
                </div>
                <div className="premium-hero-content">
                    <h1>{mainProduct.name}</h1>
                    <p className="premium-price">19.99 €</p>
                    <p className="premium-tagline">
                        Lifting straps в стил Versa Grips с подсилена поддръжка за китки за по-сигурни и тежки тренировки за теб и твоя gym buddy.
                    </p>
                    <div className="premium-color-picker" role="group" aria-label="Цвят">
                        <span className="premium-color-label">Цвят (задължително):</span>
                        <div className="premium-color-options">
                            {COLOR_OPTIONS.map(({ value, label }) => (
                                <button
                                    key={value}
                                    type="button"
                                    className={
                                        selectedColor === value
                                            ? 'premium-color-btn premium-color-btn--active'
                                            : 'premium-color-btn'
                                    }
                                    onClick={() => {
                                        setSelectedColor(value);
                                        metaTrackCustomizeProduct(mainProduct, value);
                                    }}
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                        {!canBuy && (
                            <p className="premium-color-hint">Избери зелен или сив, за да продължиш към количката.</p>
                        )}
                    </div>
                    <ul className="premium-highlights">
                        <li>Антихлъзгаща повърхност за стабилен хват</li>
                        <li>Подсилена поддръжка за китките</li>
                        <li>Идеални за мъртва тяга, набирания и гребане</li>
                    </ul>
                    <button
                        type="button"
                        className="premium-cta"
                        onClick={handleBuyClick}
                        disabled={!canBuy}
                        title={!canBuy ? 'Първо избери цвят' : undefined}
                    >
                        Купи сега - 19.99 €
                    </button>
                    <p className="premium-meta">
                        131+ потвърдени покупки · Оценка 4.7/5 · Безплатна доставка при 2 или повече артикула, иначе доставка до 3.99 €
                    </p>
                </div>
            </section>

            <section className="premium-gallery">
                <h2>Виж продукта отблизо</h2>
                <div className="premium-gallery-grid">
                    {gallery.map((img, index) => (
                        <div
                            key={`${selectedColor ?? 'none'}-${index}`}
                            className="premium-gallery-item"
                        >
                            <img src={img} alt={`${mainProduct.name} ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </section>
        </main>
    );
}

export default PremiumLanding;
